import { forwardRef, type ComponentPropsWithRef } from "react";
import {
  CoreIconButton,
  type PropsWithOptionalTestID,
} from "@boi/components-core";

import * as S from "./IconButton.styled";

export type IconButtonProps = PropsWithOptionalTestID &
  Omit<ComponentPropsWithRef<"button">, "style" | "className" | "children"> & {
    children: JSX.Element;
    variant?: CoreIconButton.Variant;
    "aria-label": string;
  };

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const {
      variant = CoreIconButton.DEFAULT_VARIANT,
      children,
      testID = "icon-button",
      ...otherProps
    } = props;

    return (
      <S.Wrapper
        {...otherProps}
        ref={ref}
        $variant={variant}
        data-testid={testID}
      >
        <S.InnerWrapper $variant={variant}>{children}</S.InnerWrapper>
      </S.Wrapper>
    );
  }
);

IconButton.displayName = "IconButton";

export default IconButton;
